import { Injectable, inject } from '@angular/core';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';

import { TenantService } from '../services/tenant.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly auth0 = inject(Auth0Service);
  private readonly tenantService = inject(TenantService);

  readonly isAuthenticated$ = this.auth0.isAuthenticated$;
  readonly isLoading$ = this.auth0.isLoading$;
  readonly user$ = this.auth0.user$;
  readonly error$ = this.auth0.error$;

  loginWithRedirect(returnTo?: string): void {
    this.auth0.loginWithRedirect({
      appState: { returnTo: returnTo ?? window.location.pathname + window.location.search }
    });
  }

  logout(): void {
    this.tenantService.clearTenant();
    this.auth0.logout({ logoutParams: { returnTo: window.location.origin } });
  }

  getAccessTokenSilently(): Observable<string> {
    return this.auth0.getAccessTokenSilently();
  }
}
